import React, { FC, ReactNode } from 'react';
import * as S from './styles';

interface BankAffiliateCTABannerProps {
  imageSrc: string;
  content: ReactNode;
  cta: ReactNode;
}

export const BankAffiliateCTABanner: FC<BankAffiliateCTABannerProps> = ({
  imageSrc,
  content,
  cta,
}) => (
  <S.Container>
    <S.Content>
      <S.Image src={imageSrc} data-testid="cta-banner-image-src"></S.Image>
      <S.Text>{content}</S.Text>
      <S.CTAContainer>{cta}</S.CTAContainer>
    </S.Content>
  </S.Container>
);
